import { Injectable } from '@angular/core';
import { Observable, Observer, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SpNetworkService {

  constructor() { }


  createOnline$() {
    return merge<boolean>(
      // offline event creation
      fromEvent(window, 'offline').pipe(map(() => false)),

      // online event creation
      fromEvent(window, 'online').pipe(map(() => true)),

      // value to observable to subscription
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }
}
